// biome-ignore lint/suspicious/noConfusingVoidType: <explanation>
export function stripNil<T>(value: T | null | undefined | void): T {
  if (value == null) {
    throw new Error("Value is nil");
  }
  return value;
}
